import { render, staticRenderFns } from "./Interesados.vue?vue&type=template&id=b6d5fc74"
import script from "./Interesados.vue?vue&type=script&lang=js"
export * from "./Interesados.vue?vue&type=script&lang=js"
import style0 from "./Interesados.vue?vue&type=style&index=0&id=b6d5fc74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports